var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('ul',{staticClass:"footer-list"},_vm._l((_vm.list),function(item,index){return _c('router-link',{attrs:{"to":{path: item.path},"tag":"li"},nativeOn:{"click":function($event){_vm.countNumber(1,(index+1))}}},[_c('span',{class:{active:index==_vm.num}}),_vm._v("\n      "+_vm._s(item.title)+"\n    ")])}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91259740","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/footer.vue
// module id = null
// module chunks = 